import React, { useState, useContext } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { CalendarContext } from '../../../../../pages/Activity/context/CalendarProvider';

import './ViewDropdown.scss';

export default function ViewDropdown() {
  const { bigCalendarView, setBigCalendarView, VIEW_TYPES } =
    useContext(CalendarContext);
  const [isViewDropdown, setIsViewDropdown] = useState(false);
  const toggleViewDropdown = () => {
    setIsViewDropdown(!isViewDropdown);
  };

  return (
    <Dropdown isOpen={isViewDropdown} toggle={toggleViewDropdown}>
      <DropdownToggle caret className="view-dropdown-toggle">
        <span>{bigCalendarView?.label}</span>
      </DropdownToggle>
      <DropdownMenu>
        {VIEW_TYPES.map(viewType => (
          <DropdownItem
            key={viewType.value}
            onClick={() => setBigCalendarView(viewType)}
          >
            <span>{viewType.label}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
